import React from 'react';
import { ImagePlaceholder, SectionWrapper, StarRating } from './ui';
import { CheckCircle2, Shield } from 'lucide-react';
export const TestimonialCards = () => {
  return <SectionWrapper className="py-12 bg-background" data-id="element-285">
      <div className="space-y-12" data-id="element-286">
        {/* Megan D. */}
        <div className="bg-white border border-sage p-6 md:p-10 rounded-sm shadow-sm" data-id="element-287">
          <StarRating rating={5} className="mb-6" data-id="element-288" />
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-primary mb-8 leading-tight" data-id="element-289">
            "I grew up running barefoot at my grandmother's place. I know
            exactly what this turns into. LEVANCE gave me the first quiet summer
            I've had since my son was born."
          </h3>

          <div className="flex items-center gap-4 mb-8 pb-8 border-b border-sage/50" data-id="element-290">
            <div className="w-14 h-14 rounded-full overflow-hidden border border-sage shrink-0" data-id="element-291">
              <img src="https://cdn.magicpatterns.com/uploads/fJM1AtWuBgf7Q2rsDqqbzE/08a82813-76c6-47a5-8f80-3c81548f0eaf.png" alt="Megan D." className="w-full h-full object-cover" data-id="element-292" />
            </div>
            <div data-id="element-293">
              <div className="font-bold text-foreground text-lg" data-id="element-294">
                — Megan D., Madison, CT
              </div>
              <div className="text-sm text-primary font-medium flex items-center mt-1" data-id="element-295">
                <CheckCircle2 className="w-4 h-4 mr-1" data-id="element-296" /> Verified Buyer
              </div>
            </div>
          </div>

          <div className="space-y-5 text-[16px] leading-[1.6] text-foreground/90" data-id="element-297">
            <p data-id="element-298">
              I'm the mom you don't want to be in the group chat with. I send
              the CDC infographic. I comment "tick check!!" on every backyard
              birthday photo. My husband thinks I'm unhinged about it. He's not
              entirely wrong.
            </p>
            <p data-id="element-299">
              I grew up running barefoot at my grandmother's place. My kids will
              never have that, and I have been quietly grieving that for nine
              years.
            </p>
            <p data-id="element-300">
              By the time I found LEVANCE, I had cycled through everything.
              Sawyer picaridin (we still use it). Insect Shield (my son wears
              his, my daughter refuses). Lemon eucalyptus that I knew in my gut
              was theater. A clip for the dog whose battery died on a hike two
              years ago. The $640-a-season yard service. So many lice combs.
            </p>
            <p data-id="element-301">
              What broke me was August. My daughter had a weird mark on her
              thigh that faded in four days. The pediatrician said "probably a
              spider bite." I have not slept right since.
            </p>
            <p data-id="element-302">
              What sold me on LEVANCE was three things. One — the founder is a
              dad whose six-year-old failed an alpha-gal panel. That's not a
              marketing story. That's my nightmare in someone else's house. Two
              — the page didn't promise me 100% anything. It said "the layer
              you've been missing" and explained Haller's organ in language I
              didn't have to Google twice. Three — the money-back guarantee.
            </p>
            <p data-id="element-303">
              I bought four. One for each kid's backpack. One for the dog. One
              for my husband's golf bag.
            </p>
            <div className="pl-6 border-l-4 border-accent my-6" data-id="element-304">
              <p className="text-lg font-serif text-primary italic leading-relaxed" data-id="element-305">
                "The morning spray still happens. The bedtime comb still
                happens. But the background process — the cognitive tax that has
                been running in my head from May through November for nine years
                — has quieted down."
              </p>
            </div>
            <p data-id="element-306">
              Last Saturday I sat on the back deck at dusk with a glass of wine
              and didn't immediately scan my own ankles. I cried a little. My
              husband didn't notice.
            </p>
            <p data-id="element-307">
              I'm not telling you LEVANCE is a miracle. I'm telling you it's the
              missing layer. And the missing layer was where my brain was
              living.
            </p>
          </div>
        </div>

        {/* Cole R. */}
        <div className="bg-white border border-sage p-6 md:p-10 rounded-sm shadow-sm" data-id="element-308">
          <StarRating rating={5} className="mb-6" data-id="element-309" />
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-primary mb-8 leading-tight" data-id="element-310">
            "Killed my first whitetail of the season covered in ticks. Then my
            buddy Doug got alpha-gal. That's when I clipped one to every pack in
            the house."
          </h3>

          <div className="flex items-center gap-4 mb-8 pb-8 border-b border-sage/50" data-id="element-311">
            <div className="w-14 h-14 rounded-full overflow-hidden border border-sage shrink-0" data-id="element-312">
              <img src="https://cdn.magicpatterns.com/uploads/jko9AahJGzyEnTmNq9V11t/6d650669-92a4-4180-82bd-768b8b0adcb2.png" alt="Cole R." className="w-full h-full object-cover" data-id="element-313" />
            </div>
            <div data-id="element-314">
              <div className="font-bold text-foreground text-lg" data-id="element-315">
                — Cole R., Litchfield County, CT
              </div>
              <div className="text-sm text-primary font-medium flex items-center mt-1" data-id="element-316">
                <CheckCircle2 className="w-4 h-4 mr-1" data-id="element-317" /> Verified Buyer
              </div>
            </div>
          </div>

          <div className="space-y-5 text-[16px] leading-[1.6] text-foreground/90" data-id="element-318">
            <p data-id="element-319">
              Forty-six years of hunting in this state and I've never seen tick
              numbers like this season. My buddy Doug — we've hunted together
              since high school — got bit two Octobers ago. Now he can't eat
              venison. Can't eat a hamburger. Has to read the label on his blood
              pressure medication for gelatin. The man hunts and can't eat what
              he kills.
            </p>
            <p data-id="element-320">
              I'm a permethrin guy. Always have been. I'm not the target
              customer for some clip-on gadget and I want to be honest about
              that.
            </p>
            <p data-id="element-321">
              What changed my mind was the founder's positioning. He said
              outright: don't stop using permethrin. LEVANCE is the layer for
              the family. For the wife who hates the smell. For the kid who
              won't wear treated clothes. For the dog. For the dusk on the deck.
              He wasn't trying to replace what I do — he was trying to cover
              what I can't.
            </p>
            <p data-id="element-322">
              Bought one for my pack. One for my wife's. One for each kid. One
              for the lab.
            </p>
            <div className="pl-6 border-l-4 border-accent my-6" data-id="element-323">
              <p className="text-lg font-serif text-primary italic leading-relaxed" data-id="element-324">
                "Three weeks later I sat in the stand for six hours and did not
                feel a single phantom crawl. That alone was worth the money."
              </p>
            </div>
            <p data-id="element-325">
              My wife says the kids stopped fighting her at the back door
              because there's nothing to spray on the in-between days. The dog
              hasn't brought one into the house in a month and a half.
            </p>
            <p data-id="element-326">
              I'm not throwing out my permethrin. I'm clipping LEVANCE next to
              it.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};
export const FuturePacing = () => {
  return <SectionWrapper className="py-12" data-id="element-327">
      <h2 className="text-3xl md:text-4xl font-serif text-primary font-bold mb-8 text-center leading-tight" data-id="element-328">
        This Quiet Little Device Has Helped Over 30,000 Families Across the Lyme
        Belt Get the Back Door Open Again.
      </h2>

      <div className="mb-10" data-id="element-329">
        <div className="w-full aspect-[16/9] overflow-hidden rounded-sm border border-sage" data-id="element-330">
          <img src="https://cdn.magicpatterns.com/uploads/qjUxHnpUH7zyL9pnumx59F/b02cf937-4698-44d7-805e-48375ac2ffdb.png" alt="A relaxed family of four in a wooded backyard in late June — mom on the deck with iced tea, dad at the grill, two kids barefoot in the grass with a goldendoodle. LEVANCE devices visible on kids' backpacks and the dog's harness. Golden hour, documentary realism." className="w-full h-full object-cover" data-id="element-331" />
        </div>
      </div>

      <p className="text-xl font-medium text-foreground/90 mb-12 text-center" data-id="element-332">
        Just imagine — the bedtime comb takes four minutes instead of fourteen.
        The back door stays open. The dog comes in clean. You sit on the deck at
        dusk and notice — for the first time in years — that you forgot to scan
        your own ankles.
      </p>

      <div className="space-y-12" data-id="element-333">
        <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-334">
          <div className="w-full md:w-1/2" data-id="element-335">
            <div className="w-full aspect-[4/3] overflow-hidden rounded-sm border border-sage" data-id="element-336">
              <img src="https://cdn.magicpatterns.com/uploads/iGRHKokhJYFahk4HfSnTxe/e9c28bdf-6d40-49d9-890a-bd2d328577d9.png" alt="A bedside scene — lamp turned off, phone face-down on a nightstand, a sleeping woman silhouetted against soft moonlight. Calm, resolved, quiet." className="w-full h-full object-cover" data-id="element-337" />
            </div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-338">
            <h3 className="text-2xl font-serif font-bold text-primary mb-3" data-id="element-339">
              No more 11 p.m. flashlight on the freckle.
            </h3>
            <p className="text-[17px] text-foreground/80" data-id="element-340">
              Sleep returns to May, June, July, August. The background process
              shuts off.
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row-reverse gap-6 items-center" data-id="element-341">
          <div className="w-full md:w-1/2" data-id="element-342">
            <div className="w-full aspect-[4/3] overflow-hidden rounded-sm border border-sage" data-id="element-343">
              <img src="https://cdn.magicpatterns.com/uploads/aNpTCMnhqaqgyntm8SHfaL/dbd7ddd7-e58a-4e0a-8d6d-b3fd2bfd51a7.png" alt="A back-door console table — the picaridin bottle pushed to the back, replaced by two LEVANCE devices clipped to small backpacks ready for school drop-off. Morning sun streaming in." className="w-full h-full object-cover" data-id="element-344" />
            </div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-345">
            <h3 className="text-2xl font-serif font-bold text-primary mb-3" data-id="element-346">
              No more "spraying them like a pesticide truck."
            </h3>
            <p className="text-[17px] text-foreground/80" data-id="element-347">
              The morning gets twelve minutes back. The kids stop flinching when
              you reach for the bottle.
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-348">
          <div className="w-full md:w-1/2" data-id="element-349">
            <div className="w-full aspect-[4/3] overflow-hidden rounded-sm border border-sage" data-id="element-350">
              <img src="https://cdn.magicpatterns.com/uploads/11MN7iVCqDysE8NWwWT5EK/514b7a67-4d31-42a2-a4c4-e4092bb000c4.png" alt="A mother on a soccer sideline in autumn, phone in hand, smiling at a photo on her screen — not typing, just watching. Other moms around her in fleece vests. Genuine relaxation." className="w-full h-full object-cover" data-id="element-351" />
            </div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-352">
            <h3 className="text-2xl font-serif font-bold text-primary mb-3" data-id="element-353">
              No more "tick check!!" on every group chat photo.
            </h3>
            <p className="text-[17px] text-foreground/80" data-id="element-354">
              You go from the family killjoy to the parent other parents text —
              "what's that thing on your kids' backpack?"
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};
export const GuaranteeCard = () => {
  return <SectionWrapper className="py-10" data-id="element-355">
      <div className="text-center mb-12" data-id="element-356">
        <h2 className="text-3xl font-serif text-primary font-bold mb-6" data-id="element-357">
          All it takes is one long-press in the morning.
        </h2>
        <p className="text-[17px] leading-[1.6] text-foreground/90 max-w-2xl mx-auto" data-id="element-358">
          Clip it on the backpack strap, the belt loop, the dog harness, the
          soccer bag. One button. Runs all day. Runs the next day. Runs the day
          after that. Recharges in the time it takes you to make dinner. No
          spray. No smell. No reapplication. No melted watch band. No "did I get
          the back of her neck?" Just the layer that closes the gap — quietly,
          in the background, while you get on with the summer you used to have.
        </p>
      </div>

      <div className="bg-sage/20 border-2 border-sage p-8 md:p-10 rounded-sm text-center max-w-2xl mx-auto" data-id="element-359">
        <div className="flex justify-center mb-6" data-id="element-360">
          <div className="bg-primary text-white p-4 rounded-full" data-id="element-361">
            <Shield className="w-10 h-10" data-id="element-362" />
          </div>
        </div>
        <h3 className="text-2xl font-serif font-bold text-primary mb-4" data-id="element-363">
          60-Day Money-Back Guarantee
        </h3>
        <p className="text-[16px] leading-[1.6] text-foreground/80" data-id="element-364">
          If LEVANCE doesn't earn its spot on your family's backpacks within
          sixty days, send it back. Full refund. No interrogation. We take the
          risk so you don't have to.
        </p>
      </div>
    </SectionWrapper>;
};